import { SearchRequestModel } from '@app/api/models/data';

export class DataExportCsvComponent {
    private readonly csvApiPath: string = "/api/data/csvtask";

    constructor(private link: HTMLAnchorElement) {
        this.link.href = this.csvApiPath;
    }

    update(data: SearchRequestModel) {
        this.link.href = `${this.csvApiPath}?${$.param(data)}`;
    }
}